import { defineComponent as r, openBlock as a, createBlock as l, unref as c, mergeProps as s, withCtx as n, renderSlot as o } from "vue";
import i from "./ghl-ui.es218.js";
const f = r({
  name: "UIAvatar",
  inheritAttrs: !1
}), u = r({
  ...f,
  props: {
    size: {
      type: [Number, String],
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    }
  },
  setup(t) {
    return (e, d) => (a(), l(c(i), s({ class: "ghl-avatar" }, e.$attrs, {
      style: t.style,
      src: t.src,
      "fallback-src": t.fallbackSrc,
      round: t.round,
      "object-fit": t.objectFit,
      size: t.size
    }), {
      default: n(() => [
        o(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]));
  }
}), y = u;
export {
  y as default
};
